/**
 * "Start from template": a link to the Templates page, beside Upload on the
 * Policies and Procedures pages and on a missing-document suggestion. Any
 * member may start a draft; filing it is still an admin's.
 *
 * @module components/regulation/templates/StartFromTemplateLink
 */
import { Link, useParams } from "@tanstack/react-router";
import { LayoutTemplateIcon } from "lucide-react";

import { Button } from "../../ui/button";

export function StartFromTemplateLink({
  forDocument,
  label = "Start from template",
  size = "sm",
}: {
  /** The document to draft, when the person came from a gap that names one. */
  readonly forDocument?: string | null;
  readonly label?: string;
  readonly size?: "sm" | "xs";
} = {}) {
  const org = useParams({
    strict: false,
    select: (params) => (params as { org?: string }).org ?? null,
  });
  if (org === null) return null;
  const wanted = forDocument?.trim();
  return (
    <Button
      size={size}
      variant="outline"
      className="cursor-pointer gap-1.5"
      render={
        <Link
          to="/$org/compliance/templates"
          params={{ org }}
          search={wanted ? { for: wanted } : {}}
        />
      }
    >
      <LayoutTemplateIcon className="size-3.5" />
      {label}
    </Button>
  );
}
